// extracted by mini-css-extract-plugin
export default {"DashboardPage":"DashboardPage_DashboardPage__Ub0df"};